<template>

    <div class="input-group | vn-input-text vn-input-textarea" :class="cssInputClass">

        <label :for="instanceId" v-html="field.title"></label>
        <textarea
            :name="key"
            :id="instanceId" type="text"
            v-model="value"
            @blur="clearError"
        ></textarea>

        <span class="error-message"  v-if="gotError"> {{ errorMessage }} </span>
    </div>

</template>

<script>

export default
{
    name: "InputTextArea"
}

</script>

<script setup>

    import useFormInput       from "../../composables/useFormInput";
    import { onMounted, ref } from 'vue';
    import { uniqueId }       from 'lodash-es';

    let props = defineProps(["field"]);

    let { gotError, clearError, cssInputClass, errorMessage, value, key, exposed } = useFormInput(props);

    defineExpose(exposed);


    let instanceId = ref( null );

    onMounted(() => {
        if ( instanceId.value === null )
        {
            instanceId.value = uniqueId( props.field.key + '_' );
        }
    })

</script>
